import { arrayToSimpleObj } from '../utils';

export const influencersTypeOptions = [
  { value: 'official', text: 'Official Accounts' },
  { value: 'unofficial', text: 'Unofficial Accounts' },
];

export const influencersTypeMap = arrayToSimpleObj(influencersTypeOptions);
